var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUnavailable = function SvgIconUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M4.5 5 19 19.826M12 22.5c5.799 0 10.5-4.701 10.5-10.5 0-5.8-4.701-10.5-10.5-10.5S1.5 6.2 1.5 12c0 5.799 4.701 10.5 10.5 10.5z"
  }));
};
export default SvgIconUnavailable;